import { render, staticRenderFns } from "./SpaymentreceiptsPdindex.vue?vue&type=template&id=bb045ff0"
import script from "./SpaymentreceiptsPdindex.vue?vue&type=script&lang=js"
export * from "./SpaymentreceiptsPdindex.vue?vue&type=script&lang=js"
import style0 from "./SpaymentreceiptsPdindex.vue?vue&type=style&index=0&id=bb045ff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports